<!--<div class="wrapper">-->
<!-- <span class="text-default">Best Practice <span class="small">1 of 12</span> </span> -->
<!--<div class="container px-0">
  <h5 class="main-title">{{patientpersonalinfo?.PracticeName}}</h5>
  <div class="main-info pb-3">-->
<!-- Check-in for my Appointment -->
<!--</div>

<div class="row justify-content-center">
  <div class="col-md-6">

    <div class="card border">

      <div class="card-header bg-info font-weight-bold mb-0 p-3 text-white">
        <h5 class="font-weight-bold text-center text-capitalize">{{patientpersonalinfo.first_Name}} {{patientpersonalinfo.last_Name}}</h5>
        <p class="text-center mb-0">
          {{appointment_details?.appointment_Date_Time | date}}-->
<!-- <sup>th</sup>  -->
<!--{{'appointmentDetails.at' |translate}} {{appointment_details?.time_From}} <br> {{'appointmentDetails.with' |translate}} <strong>Dr. {{appointment_details?.provid_FName}} {{appointment_details?.provid_LName}}</strong>
            </p>

          </div>
          <div class="card-body p-3 text-center">
            <strong class="text-center">{{appointment_details?.praC_NAME}}</strong>
            <p class="text-center mb-0">
              <span>{{appointment_details?.praC_CITY}}</span>
            </p>
            <p class="text-center mb-0"><span>{{appointment_details?.praC_ADDRESS}}</span>|<span>{{appointment_details?.praC_CITY}}, {{appointment_details?.praC_STATE}} {{appointment_details?.praC_ZIP}}</span> </p>
            <p class="text-center mb-0"><span>Phone: {{appointment_details?.praC_PHONE}}</span></p>
          </div>
          <div class="card-footer p-3" *ngIf="patientpersonalinfo.type !='check-in'">
            <h5 class="font-weight-bold text-success mb-0 text-info text-center">{{'appointmentDetails.appointmentDetails_thankyou' |translate}}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>-->


<div class="wrapper ltr-component" *ngIf="isFromcheckin">
  <div class="main-wrapper">

    <div class="container flex-grow-1 overflow-auto mt-2" [ngClass]="{'mt-5': IslandeFromQRCode || isFromSurvey}">
      <div>
        <h4 *ngIf="!isFromcheckin" class="fw-bold text-center mb-3 text-info">
          {{'appointmentDetails.appointmentDetails_thankyou' |translate}}</h4>
        <h4 *ngIf="!isFromcheckin" class="fw-bold text-center mb-3 text-info"> {{patientpersonalinfo.first_Name |
          titlecase}} {{patientpersonalinfo.last_Name | titlecase}}</h4>
        <h4 *ngIf="isFromcheckin" class="fw-bold text-center mb-3 text-info">
          <ng-container *ngIf="currentLang === 'ur'; else otherLang">
            {{patientpersonalinfo.first_Name | titlecase}} {{patientpersonalinfo.last_Name | titlecase}}
            {{'generic_text.welcome' | translate}}
          </ng-container>
          <ng-template #otherLang>
            {{'generic_text.welcome' | translate}} {{patientpersonalinfo.first_Name | titlecase}}
            {{patientpersonalinfo.last_Name | titlecase}}
          </ng-template>
        </h4>

      </div>

      <h5 class="fw-bold text-center mb-3">{{'verifypatient.appointment_detail'|translate}}</h5>
      <div class="row">
        <div class="col-md-6 mb-2">
          <div class="border-bottom d-flex align-items-center p-3">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_771_467)">
                <path
                  d="M20 7.5C20.0019 7.04123 19.8775 6.59079 19.6405 6.198C19.4035 5.80521 19.0629 5.48521 18.6562 5.27305C18.2494 5.06089 17.7921 4.96474 17.3343 4.99515C16.8766 5.02555 16.436 5.18133 16.0609 5.44542C15.6858 5.70951 15.3905 6.07174 15.2075 6.49243C15.0245 6.91312 14.9608 7.37605 15.0234 7.83054C15.0859 8.28502 15.2723 8.71353 15.5622 9.06914C15.852 9.42474 16.2341 9.69374 16.6667 9.84667V13.3333C16.6667 14.6594 16.1399 15.9312 15.2022 16.8689C14.2645 17.8065 12.9928 18.3333 11.6667 18.3333C10.3406 18.3333 9.06882 17.8065 8.13113 16.8689C7.19345 15.9312 6.66667 14.6594 6.66667 13.3333V13.2667C8.0534 13.0655 9.32151 12.3722 10.2395 11.3135C11.1574 10.2548 11.664 8.90125 11.6667 7.5V2.5C11.6667 1.83696 11.4033 1.20107 10.9344 0.732233C10.4656 0.263392 9.82971 0 9.16667 0L6.66667 0V1.66667H9.16667C9.38768 1.66667 9.59964 1.75446 9.75592 1.91074C9.9122 2.06702 10 2.27899 10 2.5V7.5C10 8.60507 9.56101 9.66488 8.77961 10.4463C7.99821 11.2277 6.9384 11.6667 5.83333 11.6667C4.72826 11.6667 3.66846 11.2277 2.88706 10.4463C2.10565 9.66488 1.66667 8.60507 1.66667 7.5V2.5C1.66667 2.27899 1.75446 2.06702 1.91074 1.91074C2.06702 1.75446 2.27899 1.66667 2.5 1.66667H5V0H2.5C1.83696 0 1.20107 0.263392 0.732233 0.732233C0.263392 1.20107 0 1.83696 0 2.5L0 7.5C0.00267996 8.90125 0.509243 10.2548 1.4272 11.3135C2.34516 12.3722 3.61327 13.0655 5 13.2667V13.3333C5 15.1014 5.70238 16.7971 6.95262 18.0474C8.20286 19.2976 9.89856 20 11.6667 20C13.4348 20 15.1305 19.2976 16.3807 18.0474C17.631 16.7971 18.3333 15.1014 18.3333 13.3333V9.84667C18.8191 9.67493 19.2399 9.35731 19.5383 8.93725C19.8366 8.51719 19.9979 8.01522 20 7.5Z"
                  fill="#455A64" />
              </g>
              <defs>
                <clipPath id="clip0_771_467">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <ng-container
              *ngIf="appointment_details?.provid_FName === 'AMI' && appointment_details?.provid_LName === 'PATEL'; else otherProvider">
              <h5 class="mb-0 ml-3 fw-bold text-info"> {{appointment_details?.provid_FName | titlecase}}
                {{appointment_details?.provid_LName | titlecase}}, NP</h5>
            </ng-container>
            <ng-template #otherProvider>
              <h5 class="mb-0 ml-3 fw-bold text-info">
                {{patientpersonalinfo?.practice_Code === '1013886' ? 'Mr.' : 'Dr.'}} {{appointment_details?.provid_FName | titlecase}}
                {{appointment_details?.provid_LName | titlecase}}
              </h5>
            </ng-template>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="border-bottom d-flex align-items-center p-3">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_771_471)">
                <path
                  d="M15.8333 1.66667H15V0.833333C15 0.61232 14.9122 0.400358 14.7559 0.244078C14.5996 0.0877974 14.3877 0 14.1667 0C13.9457 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333V1.66667H6.66667V0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0C5.61232 0 5.40036 0.0877974 5.24408 0.244078C5.0878 0.400358 5 0.61232 5 0.833333V1.66667H4.16667C3.062 1.66799 2.00296 2.1074 1.22185 2.88852C0.440735 3.66963 0.00132321 4.72867 0 5.83333L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H15.8333C16.938 19.9987 17.997 19.5593 18.7782 18.7782C19.5593 17.997 19.9987 16.938 20 15.8333V5.83333C19.9987 4.72867 19.5593 3.66963 18.7782 2.88852C17.997 2.1074 16.938 1.66799 15.8333 1.66667ZM1.66667 5.83333C1.66667 5.17029 1.93006 4.53441 2.3989 4.06557C2.86774 3.59673 3.50363 3.33333 4.16667 3.33333H15.8333C16.4964 3.33333 17.1323 3.59673 17.6011 4.06557C18.0699 4.53441 18.3333 5.17029 18.3333 5.83333V6.66667H1.66667V5.83333ZM15.8333 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V8.33333H18.3333V15.8333C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1323 18.0699 16.4964 18.3333 15.8333 18.3333Z"
                  fill="#455A64" />
                <path
                  d="M10 13.75C10.6904 13.75 11.25 13.1904 11.25 12.5C11.25 11.8096 10.6904 11.25 10 11.25C9.30964 11.25 8.75 11.8096 8.75 12.5C8.75 13.1904 9.30964 13.75 10 13.75Z"
                  fill="#455A64" />
                <path
                  d="M5.8335 13.75C6.52385 13.75 7.0835 13.1904 7.0835 12.5C7.0835 11.8096 6.52385 11.25 5.8335 11.25C5.14314 11.25 4.5835 11.8096 4.5835 12.5C4.5835 13.1904 5.14314 13.75 5.8335 13.75Z"
                  fill="#455A64" />
                <path
                  d="M14.1665 13.75C14.8569 13.75 15.4165 13.1904 15.4165 12.5C15.4165 11.8096 14.8569 11.25 14.1665 11.25C13.4761 11.25 12.9165 11.8096 12.9165 12.5C12.9165 13.1904 13.4761 13.75 14.1665 13.75Z"
                  fill="#455A64" />
              </g>
              <defs>
                <clipPath id="clip0_771_471">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <h5 class="mb-0 ml-3 text-info fw-light">{{appointment_details?.appointment_Date_Time | date}}</h5>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="border-bottom d-flex align-items-center p-3">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 19C5.03725 19 1 14.9628 1 10C1 5.03725 5.03725 1 10 1C14.9628 1 19 5.03725 19 10C19 14.9628 14.9628 19 10 19ZM10 2.5C5.8645 2.5 2.5 5.8645 2.5 10C2.5 14.1355 5.8645 17.5 10 17.5C14.1355 17.5 17.5 14.1355 17.5 10C17.5 5.8645 14.1355 2.5 10 2.5ZM13.75 10C13.75 9.58525 13.4148 9.25 13 9.25H10.75V5.5C10.75 5.08525 10.414 4.75 10 4.75C9.586 4.75 9.25 5.08525 9.25 5.5V10C9.25 10.4148 9.586 10.75 10 10.75H13C13.4148 10.75 13.75 10.4148 13.75 10Z"
                fill="#455A64" />
            </svg>
            <h5 class="mb-0 ml-3 text-info">{{appointment_details?.time_From}}</h5>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="border-bottom d-flex align-items-center justify-content-between p-3">
            <div class="d-flex">
              <span style="width: 20px;">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.50019 5.50195C8.9101 5.50195 8.33325 5.67788 7.8426 6.0075C7.35195 6.33712 6.96954 6.80561 6.74372 7.35374C6.51789 7.90187 6.45881 8.50502 6.57393 9.08691C6.68905 9.66881 6.97321 10.2033 7.39048 10.6228C7.80774 11.0424 8.33936 11.3281 8.91812 11.4438C9.49688 11.5595 10.0968 11.5001 10.642 11.2731C11.1871 11.0461 11.6531 10.6616 11.981 10.1683C12.3088 9.67496 12.4838 9.09499 12.4838 8.50169C12.4838 7.70611 12.1694 6.94312 11.6099 6.38056C11.0504 5.818 10.2915 5.50195 9.50019 5.50195ZM9.50019 10.0016C9.20514 10.0016 8.91672 9.9136 8.6714 9.74879C8.42607 9.58398 8.23486 9.34974 8.12195 9.07567C8.00904 8.8016 7.9795 8.50003 8.03706 8.20908C8.09462 7.91814 8.2367 7.65089 8.44534 7.44113C8.65397 7.23137 8.91978 7.08852 9.20916 7.03064C9.49854 6.97277 9.79849 7.00247 10.0711 7.11599C10.3437 7.22952 10.5767 7.42176 10.7406 7.66841C10.9045 7.91506 10.992 8.20505 10.992 8.50169C10.992 8.89948 10.8348 9.28098 10.5551 9.56226C10.2753 9.84354 9.89584 10.0016 9.50019 10.0016Z"
                    fill="#455A64" />
                  <path
                    d="M9.5 18.9999C8.87191 19.0032 8.2522 18.8551 7.69274 18.568C7.13328 18.281 6.65037 17.8633 6.28444 17.3501C3.44182 13.4077 2 10.4439 2 8.5406C2 6.54071 2.79018 4.62273 4.1967 3.20859C5.60322 1.79445 7.51088 1 9.5 1C11.4891 1 13.3968 1.79445 14.8033 3.20859C16.2098 4.62273 17 6.54071 17 8.5406C17 10.4439 15.5582 13.4077 12.7156 17.3501C12.3496 17.8633 11.8667 18.281 11.3073 18.568C10.7478 18.8551 10.1281 19.0032 9.5 18.9999ZM9.5 2.63711C7.94288 2.6389 6.45004 3.2616 5.34898 4.36861C4.24793 5.47563 3.62858 6.97655 3.6268 8.5421C3.6268 10.0495 5.03879 12.837 7.60169 16.3909C7.81926 16.6922 8.1047 16.9375 8.43464 17.1066C8.76459 17.2757 9.12966 17.3638 9.5 17.3638C9.87034 17.3638 10.2354 17.2757 10.5654 17.1066C10.8953 16.9375 11.1807 16.6922 11.3983 16.3909C13.9612 12.837 15.3732 10.0495 15.3732 8.5421C15.3714 6.97655 14.7521 5.47563 13.651 4.36861C12.55 3.2616 11.0571 2.6389 9.5 2.63711Z"
                    fill="#455A64" />
                </svg>
              </span>

              <h5 class="mb-0 ml-3 text-info">
                <span>
                  <a href="https://www.google.com/maps/place/{{appointmentAddress}}, {{appointmentCity}}, {{appointmentState}} {{appointmentZip}}"
                    target="_blank">
                    {{appointmentAddress | titlecase}}, {{appointmentCity|titlecase}}, {{appointmentState}}
                    {{appointmentZip}}
                  </a>
                </span>
              </h5>
            </div>

          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="border-bottom d-flex align-items-center p-3">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.6304 2.3627L16.8429 1.68041C15.9354 0.773196 14.4654 0.773196 13.5579 1.68041C13.5354 1.70291 12.1479 3.50984 12.1479 3.50984C11.2929 4.40956 11.2929 5.82662 12.1479 6.71884L13.0179 7.8135C11.9229 10.2952 10.2204 12.0047 7.82039 13.0244L6.72539 12.1471C5.83289 11.2849 4.40789 11.2849 3.51539 12.1471C3.51539 12.1471 1.70789 13.5342 1.68539 13.5567C0.777887 14.4639 0.777887 15.9335 1.64789 16.8032L2.39789 17.6654C3.26039 18.5276 4.42289 19 5.68289 19C11.4129 19 19.0029 11.4049 19.0029 5.68416C19.0029 4.43205 18.5304 3.26242 17.6304 2.3702V2.3627ZM5.68289 17.493C4.82789 17.493 4.04039 17.1781 3.50039 16.6307L2.75039 15.7685C2.44289 15.4611 2.42789 14.9588 2.72039 14.6364C2.72039 14.6364 4.51289 13.2568 4.53539 13.2343C4.84289 12.9269 5.38289 12.9269 5.69789 13.2343C5.72039 13.2568 7.22789 14.4639 7.22789 14.4639C7.43789 14.6289 7.71539 14.6739 7.96289 14.5764C11.0679 13.3918 13.2954 11.1724 14.5779 7.97095C14.6754 7.72352 14.6379 7.43861 14.4654 7.22118C14.4654 7.22118 13.2579 5.70665 13.2429 5.69166C12.9204 5.36926 12.9204 4.85192 13.2429 4.52952C13.2654 4.50703 14.6454 2.71509 14.6454 2.71509C14.9679 2.42268 15.4704 2.43018 15.8154 2.77507L16.6029 3.45736C17.1804 4.03468 17.5029 4.82193 17.5029 5.67666C17.5029 10.895 10.1754 17.493 5.68289 17.493Z"
                fill="#455A64" />
            </svg>
            <h5 class="mb-0 ml-3 text-info">
              <a href={{phoneLink}}>{{appointment_details?.praC_PHONE}}</a>
            </h5>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>


<div class="wrapper wrapper-nofooter" *ngIf="!isFromcheckin">
  <div class="container px-0">

    <ng-container *ngIf="appointment_details?.provid_FName === 'AMI' && appointment_details?.provid_LName === 'PATEL'; else otherProvider">
      <h5 class="font-weight-bold mb-0 p-3 text-center">
        <i class="fas fa-check-circle   mb-3" [ngClass]="isDrsite ? 'check-icon-blue' : 'check-icon'"></i>
        <br>
        <span *ngIf="isForReschedule || isAfterCancel">
          {{'checkin_thankyou.reschedule_completed' |translate}}
          {{appointment_details?.provid_FName | titlecase}}
          {{appointment_details?.provid_LName | titlecase}}, NP
        </span>
        <span *ngIf="isForReschedule !=true && isAfterCancel !=true">
          {{'checkin_thankyou.schedule_completed' |translate}}
          {{appointment_details?.provid_FName | titlecase}}
          {{appointment_details?.provid_LName | titlecase}}, NP
        </span>

      </h5>
    </ng-container>
    <ng-template #otherProvider>
      <h5 class="font-weight-bold mb-0 p-3 text-center">
        <i class="fas fa-check-circle   mb-3" [ngClass]="isDrsite ? 'check-icon-blue' : 'check-icon'"></i>
        <br>
        <span *ngIf="isForReschedule || isAfterCancel">
          {{'checkin_thankyou.reschedule_completed'|translate}}
          {{patientpersonalinfo?.practice_Code === '1013886' ? 'Mr.' : 'Dr.'}} {{appointment_details?.provid_FName | titlecase}}
          {{appointment_details?.provid_LName | titlecase}}
        </span>
        <span *ngIf="isForReschedule !=true && isAfterCancel !=true">
          {{'checkin_thankyou.schedule_completed'|translate}}
          {{patientpersonalinfo?.practice_Code === '1013886' ? 'Mr.' : 'Dr.'}} {{appointment_details?.provid_FName | titlecase}}
          {{appointment_details?.provid_LName | titlecase}}
        </span>
      </h5>
    </ng-template>

    <!--<h5 class="font-weight-bold mb-0 p-3 text-center">
    <i class="fas fa-check-circle   mb-3" [ngClass]="isDrsite ? 'check-icon-blue' : 'check-icon'"></i>
    <br>
    <span *ngIf="isForReschedule || isAfterCancel">{{'checkin_thankyou.reschedule_completed' |translate : {
      ProviderName: ProviderName } }}</span>
    <span *ngIf="isForReschedule !=true && isAfterCancel !=true">{{'checkin_thankyou.schedule_completed'
      |translate : {ProviderName: ProviderName } }}</span>

  </h5>-->


    <div class="row justify-content-center">
      <div class="col-md-6">

        <div class="card border">
          <div class="card-header font-weight-bold mb-0 p-3 text-white border-bottom"
               [ngClass]="isDrsite ? 'bg-info-blue' : 'bg-info'">
            <h5 class="fw-bold text-center mb-0">{{'verifypatient.appointment_detail'|translate}}</h5>
          </div>
          <div class="card-header font-weight-bold mb-0 p-3 text-white"
               [ngClass]="isDrsite ? 'bg-info-blue' : 'bg-info'">

            <h5 class="font-weight-bold text-center text-capitalize">
              {{patientpersonalinfo.first_Name | titlecase}}
              {{patientpersonalinfo.last_Name | titlecase}}
            </h5>
            <p class="text-center mb-0">
              {{appointment_details?.appointment_Date_Time | date}}
              {{'appointmentDetails.at' | translate}}
              {{appointment_details?.time_From}}
            </p>

          </div>

          <div class="card-body p-3 text-center">
            <!--<strong class="text-center">{{appointment_details?.praC_NAME}}</strong>
          <br> <br>-->
            <p class="text-center mb-0">
              <a class="addrLink"
                 href="https://www.google.com/maps/place/{{appointmentAddress}}, {{appointmentCity}}, {{appointmentState}} {{appointmentZip}}"
                 target="_blank">
                {{appointmentAddress | titlecase}}, {{appointmentCity|titlecase}}, {{appointmentState}}
                {{appointmentZip}}
              </a>

            </p>
            <br>
            <strong class="text-center mb-0">
              <span>
                {{'checkin_thankyou.phone'|translate}}:
                <a href={{phoneLink}} class="ltr-component" [ngClass]="isDrsite ? 'a-blue' : 'a-normal'"
                   style="direction: ltr; display: inline-block;">
                  {{appointment_details?.praC_PHONE}}
                </a>
              </span>
            </strong>

          </div>
        </div>
      </div>

    </div>

  </div>

</div>

<footer>
  <div class="container" *ngIf="patientpersonalinfo.type =='check-in' && !isFromSurvey">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-6 col-12" style="padding: 0px 30px 0px 30px">
        <button class="btn btn-primary w-100" type="button"
          (click)="checkin()">{{'verifypatient.good_to_go'|translate}}</button>
      </div>
    </div>
  </div>
  <div class="container" *ngIf="isFromSurvey">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-6 col-12" style="padding: 0px 30px 0px 30px">
        <button class="btn btn-primary w-100" type="button"
          (click)="goToSurvey()">{{'afterVisitSurvey.startSurvey'|translate}}</button>
      </div>
    </div>
  </div>
  <div class="container" *ngIf="isForReschedule">
    <!--<div class="container" *ngIf="!isFromcheckin">-->
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-6 col-12" style="padding: 0px 30px 0px 30px">
        <button class="btn btn-primary w-100" type="button"
          (click)="checkinAfterReschedule()">{{'verifypatient.good_to_go'|translate}}</button>
      </div>
    </div>
  </div>
</footer>

<footer class="p-3" *ngIf="!isFromcheckin && !isForReschedule">
  <div class="container p-0">
    <div class="d-flex justify-content-center align-items-center">
      <button class="btn" [ngClass]="isDrsite ? 'blue-btn' : 'btn-primary'"
        (click)="addToCalendar()">{{'button.add_to'|translate}} <i class="fas fa-calendar-plus fa-lg"></i> </button>
    </div>
  </div>
</footer>




<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="language-modal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'button.change_language' | translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body ">
        <div class="row">
          <div class="col">
            <div class=" d-flex justify-content-left align-items-end" (click)="selectLanguage('en')"
              style="margin-top:10px">
              <img width="32" class="mr-3" src="assets/images/america-flag.png" />English
            </div>

            <div class="devider" style="margin-bottom:25px"> </div>
            <div class=" d-flex justify-content-left align-items-end" (click)="selectLanguage('es')">
              <img width="32" class="mr-3" src="assets/images/spanish.png" />Spanish
            </div>

            <div class="devider" style="margin-bottom:25px"></div>
            <div class=" d-flex justify-content-left align-items-end" (click)="selectLanguage('hi')"
              style="margin-bottom:12px">
              <img width="32" class="mr-3" src="assets/images/india_flag.png" />Hindi
            </div>

            <!--<div class="devider" style="margin-bottom:25px"></div>
            <div class=" d-flex justify-content-left align-items-end" (click)="selectLanguage('gu')"
                 style="margin-bottom:12px">
              <img width="32" class="mr-3" src="assets/images/india_flag.png" />Gujrati
            </div>-->

            <div class="devider" style="margin-bottom:25px"></div>
            <div class=" d-flex justify-content-left align-items-end" (click)="selectLanguage('ur')"
              style="margin-bottom:12px">
              <img width="32" class="mr-3" src="assets/images/pakistan.png" />Urdu
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
